document.addEventListener("DOMContentLoaded", function () {
  const initSwiper = () => {
    const swiperContainer = document.querySelector(".akta-testimonial-swiper");
    if (!swiperContainer) return;

    new Swiper(".akta-testimonial-swiper", {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 29,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 29,
          centeredSlides: true,
        },
        990: {
          slidesPerView: 2.5,
          spaceBetween: 29,
          centeredSlides: true, // Keep centered for that "full width but focused" look
        },
      },
    });
  };

  // Initialize if Swiper is already loaded
  if (typeof Swiper !== "undefined") {
    initSwiper();
  } else {
    // Wait for script load if needed (though script tag order usually handles this)
    window.addEventListener("load", initSwiper);
  }
});
